module.exports = __webpack_public_path__ + "static/media/DSC_0129.76119baf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0129.jpg
// module id = 558
// module chunks = 0